// Bible books with their chapter counts (German names)
export const BIBLE_BOOKS_WITH_CHAPTERS: Record<string, number> = {
    // Old Testament
    "1. Mose": 50,
    "2. Mose": 40,
    "3. Mose": 27,
    "4. Mose": 36,
    "5. Mose": 34,
    Josua: 24,
    Richter: 21,
    Ruth: 4,
    "1. Samuel": 31,
    "2. Samuel": 24,
    "1. Könige": 22,
    "2. Könige": 25,
    "1. Chronik": 29,
    "2. Chronik": 36,
    Esra: 10,
    Nehemia: 13,
    Esther: 10,
    Hiob: 42,
    Psalmen: 150,
    Sprüche: 31,
    Prediger: 12,
    Hoheslied: 8,
    Jesaja: 66,
    Jeremia: 52,
    Klagelieder: 5,
    Hesekiel: 48,
    Daniel: 12,
    Hosea: 14,
    Joel: 3,
    Amos: 9,
    Obadja: 1,
    Jona: 4,
    Micha: 7,
    Nahum: 3,
    Habakuk: 3,
    Zephanja: 3,
    Haggai: 2,
    Sacharja: 14,
    Maleachi: 4,
    // New Testament
    Matthäus: 28,
    Markus: 16,
    Lukas: 24,
    Johannes: 21,
    Apostelgeschichte: 28,
    Römer: 16,
    "1. Korinther": 16,
    "2. Korinther": 13,
    Galater: 6,
    Epheser: 6,
    Philipper: 4,
    Kolosser: 4,
    "1. Thessalonicher": 5,
    "2. Thessalonicher": 3,
    "1. Timotheus": 6,
    "2. Timotheus": 4,
    Titus: 3,
    Philemon: 1,
    Hebräer: 13,
    Jakobus: 5,
    "1. Petrus": 5,
    "2. Petrus": 3,
    "1. Johannes": 5,
    "2. Johannes": 1,
    "3. Johannes": 1,
    Judas: 1,
    Offenbarung: 22,
};

export const BIBLE_BOOKS = Object.keys(BIBLE_BOOKS_WITH_CHAPTERS);

/**
 * Assembles a bible passage string from its components.
 * Format: "Book Chapter:Verses" or "Book Chapter" (if no verses).
 */
export function assembleBiblePassage(book: string, chapter: string, verses: string): string {
    const normalizedBook = book.trim();
    const normalizedChapter = chapter.trim();
    const normalizedVerses = verses.trim();

    if (!normalizedBook || !normalizedChapter) return "";
    return `${normalizedBook} ${normalizedChapter}${normalizedVerses ? ":" + normalizedVerses : ""}`;
}

/**
 * Parses a bible passage string into its components.
 * Supports formats like "Johannes 3:16", "1. Korinther 13:1-7", "Psalmen 23".
 */
export function parseBiblePassage(passage: string): { book: string; chapter: string; verses: string } {
    if (!passage) return { book: "", chapter: "", verses: "" };
    const match = passage.match(/^(.*?)\s+(\d+)(?::(.+))?$/);
    if (match) {
        return {
            book: match[1].trim(),
            chapter: match[2],
            verses: match[3] || "",
        };
    }
    return { book: "", chapter: "", verses: "" };
}
